// extracted by mini-css-extract-plugin
export default {"features":"Features_features__Z0ymW","container":"Features_container__RLjrS","title":"Features_title__T3nIU"};